/**
 * @author 仇兴洲
 * @description 校验工具
 */
const validate = {}

/**
 * @description 对Element ui多个表单进行校验
 * @param {Array} formArray 表单数组
 * @param {Function} callback 回调函数
 */
validate.formValidate = function(formArray = [], callback = () => {}) {
  return Promise.all(
    formArray.map((form) => {
      return new Promise((resolve) => {
        form.validate((res) => {
          resolve(res)
        })
      })
    })
  )
    .then((res) => {
      const valid = res.every((item) => !!item)
      callback(valid)
      return valid
    })
    .catch((err) => {
      console.log(err)
    })
}

export default validate
